import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { EventReportManager } from '../event-report/event-report-manager'
import { buildContactUsHref } from '../common/contact-us-link'

type BaseMessage = {
  type: string
  data?: Record<string, any>
}

export default function useIframeMessage() {
  const router = useRouter()

  const { robot } = router.query as { robot: string }

  useEffect(() => {
    function listener(ev: MessageEvent) {
      const message = (ev.data || {}) as BaseMessage
      switch (message.type) {
        case 'contact-us':
          fireContactEvent()
          router.push(buildContactUsHref(robot))
          break
        default:
          break
      }
    }
    window.addEventListener('message', listener)

    return () => {
      window.removeEventListener('message', listener)
    }
  }, [])

  function fireContactEvent() {
    const event = { action: '', data: { event: 'initiate_lead' } }
    EventReportManager.getInstance().fireEventImmediately(event, true)
  }
}
